export enum WageType {
  Hour = 1,
  Day = 2,
  BiWeek = 3,
  Week = 4,
  Month = 5,
  Year = 6,
  Flat = 7,
}

export interface IWageTypeConfig {
  id: number;
  type: string;
  standard: string;
}

export const WageTypeList: IWageTypeConfig[] = Object.keys(WageType)
  .filter((key) => !isNaN(Number(WageType[key])))
  .map((x, i) => ({ id: i + 1, type: x, standard: x }));

export const WAGE_TYPES: IWageTypeConfig[] = [
  { id: 1, type: 'hourly', standard: 'hour' },
  { id: 2, type: 'daily', standard: 'day' },
  { id: 3, type: 'bi-weekly', standard: 'bi-week' },
  { id: 4, type: 'weekly', standard: 'week' },
  { id: 5, type: 'monthly', standard: 'month' },
  { id: 6, type: 'annually', standard: 'year' },
  { id: 7, type: 'flat', standard: 'flat' },
];
